import React from 'react'
import clsx from 'clsx'
import { LocationDate } from '../index'
import { useMediaQuery } from '../../hooks/useMediaQuery'
import { allPostParams } from '../../types'
import { HeroSlideInfos } from './HeroSlideInfos'
import { HeroSlideTitle } from './HeroSlideTitle'
import style from './style.module.scss'

export const HeroSlide: React.FC<allPostParams> = ({
    date,
    title,
    parentTax,
    tax,
    thumbnail,
    thumbnail_mobile,
    link,
    readingTime,
    location,
    place,
    access,
    price,
    eventDate,
}) => {
    const isTablet = useMediaQuery('(max-width: ' + style.tabletBreakpoint + ')')
    const isEvent = location || place || access || price || eventDate

    const imageTag = isTablet && thumbnail_mobile ? thumbnail_mobile?.tag : thumbnail?.tag

    return (
        <div className={clsx(style.block, isEvent ? style.blockEvent : undefined)}>
            <div className={style.left}>
                <div className={style.content}>
                    <HeroSlideTitle
                        className={style.title}
                        title={title}
                        parentTax={parentTax}
                        tax={tax}
                        link={link}
                    />

                    <HeroSlideInfos
                        date={date}
                        readingTime={readingTime}
                        access={access}
                        price={price}
                    />
                </div>

                {!isTablet && (
                    <LocationDate
                        classNames={[style.locationDate]}
                        location={location}
                        place={place}
                        date={eventDate}
                    />
                )}
            </div>

            <a href={link} className={style.right}>
                {imageTag && <picture dangerouslySetInnerHTML={{ __html: imageTag }} />}

                {isTablet && (
                    <LocationDate
                        classNames={[style.locationDateMobile]}
                        location={location}
                        place={place}
                        date={eventDate}
                    />
                )}
            </a>
        </div>
    )
}
